import React from "react"
import PropTypes from "prop-types"

class SelectButton extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
      return(
        <button
          onClick={() => this.props.onClick()}
          className={this.props.selected ? 'select_button_primary' : 'select_button_secondary'}
          style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
          <div>{this.props.buttonText}</div>
          <div className="checkmark_icon"></div>
        </button>)
  }
}

export default SelectButton;
